// import { UserProfile } from './type';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapToUserProfile = (r: any): any => {
  // 職歴・学歴のマッピング
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const mapHistoryLog = (params: any) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const historyLog = params.map((r: any) => {
      const attributes = {
        id: r.attributes.id,
        profileHistoryLogId: r.profile_history_log_id,
        organizationName: r.attributes.organization_name,
        industryId: r.attributes.industry_id,
        employeesScale: r.attributes.employees_scale,
        employmentType: r.attributes.employment_type,
        jobExperience: r.attributes.job_experience,
        schoolType: r.attributes.school_type,
        schoolName: r.attributes.school_name,
        schoolBelongs: r.attributes.school_belongs
      };

      return {
        id: r.id,
        type: r.type,
        startAt: r.start_at !== null ? String(r.start_at) : null,
        endAt: r.end_at !== null ? String(r.end_at) : null,
        isActive: r.is_active,
        attributes
      };
    });

    return historyLog;
  };

  // 希望条件のマッピング
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const mapRequirement = (params: any) => {
    return {
      areas: params.areas,
      employeesScales: params.employees_scales,
      industries: params.industries,
      occupations: params.occupations,
      salaries: params.salaries,
      features: params.features
    };
  };

  // 希望ステータスのマッピング
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const mapWillingnessStatus = (params: any): any => {
    return {
      id: params !== null ? params.id : null,
      careerChange: params !== null ? params.career_change : null,
      sideJob: params !== null ? params.side_job : null,
      latestSalary: params !== null ? params.latest_salary : null,
      plan: params !== null ? params.plan : null,
      aboutMyself: params !== null ? params.about_myself : null
    };
  };

  // 資格・受賞歴のマッピング
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const mapCertificationAwardLog = (params: any): any => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return params.map((r: any) => {
      return {
        id: r.id,
        name: r.name,
        year: Number(r.acquired_at.substr(0, 4)),
        month: Number(r.acquired_at.substr(4, 2))
      };
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const mapImportantItem = (params: any): any => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return params.map((r: any) => {
      return {
        id: r.id,
        importantItemId: Number(r.important_item_id)
      };
    });
  };

  return {
    userId: r.id,
    yearOfBirth: r.birth_date ? Number(r.birth_date.split('-')[0]) : null,
    monthOfBirth: r.birth_date ? Number(r.birth_date.split('-')[1]) : null,
    dayOfBirth: r.birth_date ? Number(r.birth_date.split('-')[2]) : null,
    mobilePhone: r.mobile_phone,
    lastName: r.last_name,
    firstName: r.first_name,
    locale: r.locale,
    icon: r.icon,
    cover: r.cover,
    passwordRegistered: r.password_registered,
    settings: {
      id: r.settings.id,
      userId: r.settings.user_id,
      atteluCareerStatus: r.settings.attelu_career_status,
      isReceivableNotifications: r.settings.is_receivable_notifications,
      isPublishedProfile: r.settings.is_published_profile
    },
    attributes: {
      historyLogs: mapHistoryLog(r.attributes.history_logs),
      requirements: mapRequirement(r.attributes.requirements),
      uploadFiles: r.attributes.upload_files,
      willingnessStatuses: mapWillingnessStatus(
        r.attributes.willingness_statuses
      ),
      awardLogs: mapCertificationAwardLog(r.attributes.award_logs),
      certificationLogs: mapCertificationAwardLog(
        r.attributes.certification_logs
      ),
      importantItems: mapImportantItem(r.attributes.important_items)
    },
    agreedWithTerms: r.agreed_with_terms,
    createdAt: r.created_at
  };
};
